var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsOnion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1264 0C22.5476 1.51784 22.8985 3.03568 23.3986 4.50088C24.0216 6.33457 24.6883 8.15949 25.478 9.92299C26.9695 13.2657 27.8907 16.7401 28.2855 20.3812C28.6365 23.645 28.6365 26.8912 28.0136 30.1024C27.2415 34.0768 25.7412 37.7091 22.6353 40.5079C22.258 40.8501 22.0475 40.8501 21.6965 40.5254C19.354 38.3847 17.8976 35.6999 16.9675 32.7081C15.6515 28.488 15.6427 24.1714 16.099 19.8372C16.4411 16.6173 17.2922 13.529 18.5819 10.5459C19.6523 8.04543 20.5735 5.46598 21.4772 2.8953C21.8018 1.98284 21.9159 0.982648 22.1264 0Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0512 39.7534C25.9198 38.1039 26.8674 36.472 27.6658 34.7612C28.7186 32.5151 29.1836 30.0848 29.3766 27.637C29.6837 23.7678 29.4205 19.9162 28.6309 16.0909C27.9904 13.0376 26.6393 10.2564 25.4987 7.39618C25.0074 6.15033 24.5599 4.88692 24.1914 3.57965C25.3934 5.53617 26.9112 7.20316 28.5344 8.78242C29.7714 9.97563 31.0436 11.1338 32.2105 12.3972C34.2723 14.6169 35.448 17.3016 36.1411 20.2232C36.7553 22.8202 37.0711 25.4172 36.3341 28.0406C35.72 30.234 34.5969 32.1642 33.0879 33.8487C30.8155 36.3755 28.043 38.2267 25.0249 39.7358C24.9986 39.7621 24.9372 39.7183 25.0512 39.7534Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4583 39.6481C14.9574 37.5073 11.0093 34.7524 8.77197 30.1462C7.34187 27.1895 7.40328 24.0837 8.01744 20.9164C8.8948 16.4418 11.176 12.8709 14.5713 9.89668C16.3875 8.29988 18.1334 6.61534 19.4407 4.54476C19.546 4.37806 19.7039 4.24646 20.0198 4.17627C19.7127 5.02731 19.4319 5.88713 19.1073 6.7294C18.2124 9.01054 17.1859 11.239 16.4314 13.5641C15.8435 15.3802 15.4048 17.2753 15.2031 19.1704C14.9398 21.5832 14.817 24.031 14.9047 26.4613C15.0539 30.6288 16.0716 34.5945 18.3703 38.1478C18.5458 38.4286 18.7388 38.6918 18.9318 38.9637C19.0985 39.1919 19.2828 39.42 19.4583 39.6481Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0372 1.29852C19.5722 2.18466 19.1423 3.08834 18.6335 3.94816C17.2209 6.30827 15.1065 8.03668 13.1412 9.88791C10.7986 12.0901 8.92105 14.5994 7.9033 17.6701C6.73641 21.1884 6.03452 24.7505 7.11367 28.4442C8.2367 32.3046 10.6845 35.2086 13.8431 37.5337C15.3258 38.6304 16.984 39.4902 18.5545 40.4553C18.7037 40.5518 18.8353 40.6658 19.0721 40.8413C16.5102 40.5869 14.1765 39.885 12.0006 38.7795C8.61397 37.0599 5.8415 34.612 3.80601 31.3833C1.46345 27.6721 0.419389 23.645 1.32307 19.2933C1.91968 16.4155 3.43752 13.9764 5.81518 12.2129C7.4383 11.0109 9.21935 10.0195 10.939 8.94036C13.8782 7.08913 16.5278 4.88694 18.8879 2.33381C19.0546 2.14956 19.1599 1.89513 19.3178 1.70211C19.4757 1.51786 19.6688 1.35994 19.853 1.19324C19.9056 1.23711 19.9758 1.2722 20.0372 1.29852Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3981 40.7711C26.679 39.999 27.9951 39.2708 29.2409 38.446C32.0485 36.5773 34.4525 34.2961 36.0668 31.278C37.6461 28.3213 38.1199 25.1978 37.5145 21.9077C37.0495 19.3546 36.3388 16.8892 35.0403 14.6168C33.7769 12.3971 32.0046 10.6336 30.1534 8.92275C28.2144 7.12415 26.3018 5.308 25.0822 2.9128C24.7401 2.23723 24.4505 1.54411 24.082 0.736938C25.4069 2.14949 26.565 3.51818 27.8635 4.73772C30.4429 7.17679 33.4172 9.09822 36.523 10.8003C41.796 13.6781 44.4369 19.8372 42.9541 25.6716C41.41 31.7167 37.6899 35.9631 32.2678 38.8233C31.215 39.376 30.0744 39.7884 28.9339 40.1306C27.7933 40.4728 26.6001 40.657 25.4332 40.9114C25.4069 40.8588 25.3981 40.8149 25.3981 40.7711Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5216 45.0001C22.7319 45.0703 22.4512 44.2806 22.4512 42.1311C23.0478 41.903 23.39 42.0872 23.39 42.7453C23.39 43.2454 23.311 43.7367 23.3198 44.2368C23.3198 44.4649 23.4426 44.7018 23.5216 45.0001Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4226 42.1837C20.1945 42.8066 20.0015 43.4383 19.7207 44.0349C19.6418 44.2104 19.3171 44.2806 19.1066 44.4034C19.0188 44.1929 18.8258 43.956 18.8697 43.7805C18.9925 43.2629 19.1417 42.7277 19.4224 42.289C19.5628 42.0696 19.9927 42.0258 20.291 41.8942C20.3349 41.9907 20.3787 42.0872 20.4226 42.1837Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9275 42.0872H21.8224C21.8224 42.789 21.8487 43.4471 21.8048 44.1051C21.7873 44.2893 21.5416 44.4648 21.4012 44.6403C21.2433 44.456 20.9626 44.2718 20.945 44.0788C20.8924 43.4383 20.9275 42.7978 20.9275 42.0872Z",
    fill: "#E38F52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_138_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 43,
    height: 45
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3591 0H1V45H43.3591V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_138_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9723 42.0608C24.5426 42.0608 25.534 43.3768 25.5164 44.3946C24.8497 43.5786 24.3057 42.9206 23.7617 42.2538C23.8407 42.1924 23.9021 42.131 23.9723 42.0608Z",
    fill: "#E38F52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsOnion);
export default __webpack_public_path__ + "static/media/ic-crops-Onion.5c532f0639583d65c877a2874bbeb94f.svg";
export { ForwardRef as ReactComponent };